import { useEffect, useState } from 'react';

export function useIsDesktop() {
    const [isDesktop, setIsDesktop] = useState(false);

    useEffect(() => {
        const hoverMediaQuery = window.matchMedia('(hover: hover)');
        setIsDesktop(hoverMediaQuery.matches);

        const checkIsDesktop = () => {
            setIsDesktop(hoverMediaQuery.matches);
        };

        hoverMediaQuery.addEventListener('change', checkIsDesktop);

        return () => {
            hoverMediaQuery.removeEventListener('change', checkIsDesktop);
        };
    }, []);

    return isDesktop;
}
